import { PaginatedTable, Column, Tooltip, Icon, TableRowExtras, TableCellExtras } from '@gcl/react-core';
import * as React from 'react';
import {
  IProjectTransmittalHistoryItem,
  IProjectTransmittalHistoryItemRevision,
} from '@transmittal/history/transmittalHistory.models';
import { isPositiveNumber } from '@core/Primitives/number.services';
import { createTransmittalItemDownloadColumn } from './transmittalItemTableColumn.utils';

export const ProjectTransmittalHistoryItemPlaceHolder: IProjectTransmittalHistoryItem = {
  id: 0,
  projectId: 0,
  masterScheduleId: 0,
  docNo: undefined,
  description: undefined,
  inUse: true,
  siteInUse: true,
  latestRevision: undefined,
  rowVersion: '',
};

export interface ILatestTransmittalRevisionListProps {
  transmittalHistoryItems: IProjectTransmittalHistoryItem[];
  transmittalItemsLatestRevision?: IProjectTransmittalHistoryItemRevision[];
  headerText?: string;
}

export const LatestTransmittalRevisionList: React.FunctionComponent<ILatestTransmittalRevisionListProps> = ({
  transmittalHistoryItems,
  transmittalItemsLatestRevision,
  headerText = 'Pkg',
}) => {
  const columns: Column[] = React.useMemo(() => {
    return [
      createTransmittalItemDownloadColumn(
        'lastTransmittalRevision.revisionNo',
        headerText,
        (
          value,
          item: IProjectTransmittalHistoryItem,
          index: number,
          cellExtras: TableCellExtras,
          rowExtras: TableRowExtras,
        ) => {
          if (isPositiveNumber(item.lastTransmittalId))
            return {
              defaultElement: (
                <Tooltip overlay="Removed From Use" id="gcl-gems-transmttal-history-page-removed-from-use">
                  <Icon iconName="LockFill" className="gcl-gems-transmittal-history-page-removed-from-use" />
                </Tooltip>
              ),
            };

          const { transmittalItemsLatestRevision: transmittalItemsLatestRevisionLocal } = cellExtras;

          const found = ((transmittalItemsLatestRevisionLocal ?? []) as IProjectTransmittalHistoryItemRevision[]).find(
            (rev) => rev.itemId === item.id,
          );

          if (!found || !isPositiveNumber(found.id)) return {};

          return {
            projectFileId: found.projectFile.id,
            projectId: item.projectId,
            displayText: found.revisionNo,
          };
        },
        true,
      ),
    ];
  }, []);

  return (
    <PaginatedTable
      columns={columns}
      items={transmittalHistoryItems || []}
      disablePagination
      allowExpandRow={false}
      allowSelectRow={false}
      hoverHighlight={false}
      responsive={false}
      cellExtras={{ transmittalItemsLatestRevision }}
    />
  );
};
